import { render, staticRenderFns } from "./SubmitVerification.vue?vue&type=template&id=0dff27ed&"
import script from "./SubmitVerification.vue?vue&type=script&lang=js&"
export * from "./SubmitVerification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports